import NextLink from 'next/link';

import {Button, Card, Text} from '#component/base';
import {HorizontalProgressTracker, ProgressTracker} from '#component/partial';
import {useViewportSize} from '#hook';
import {sprinkles} from '#style/sprinkles';

import {RightTileProps} from './RightTile.types';

import * as css from './RightTile.css';

export const RightTile = ({
  title,
  mainInfo,
  secondaryInfo,
  primaryButton,
  secondaryButton,
  steps,
}: RightTileProps) => {
  const {isDesktop} = useViewportSize();
  const {mostRecentStatusIndex = 0, progressTrackerItems = []} = steps || {};
  let currentItemStatus: 'completed' | 'in-progress' = 'in-progress';

  if (progressTrackerItems) {
    currentItemStatus =
      mostRecentStatusIndex >= progressTrackerItems.length - 1 ? 'completed' : 'in-progress';
  }

  const renderedProgressTracker = isDesktop ? (
    <HorizontalProgressTracker
      items={progressTrackerItems}
      currentItemIndex={mostRecentStatusIndex + 1}
      currentItemStatus={currentItemStatus}
    />
  ) : (
    <ProgressTracker
      items={progressTrackerItems}
      currentItemIndex={mostRecentStatusIndex + 1}
      currentItemStatus={currentItemStatus}
    />
  );

  return (
    <Card className={css.root}>
      <div className={sprinkles({dir: 'col', flex: 'flex', gap: [24, 32]})}>
        <Text as="h2" color="deepBurgundy" variant="heading2">
          {title}
        </Text>

        {mainInfo && (
          <Text as="p" color="doveGray" variant="bodyLarge">
            {mainInfo}
          </Text>
        )}

        {secondaryInfo && (
          <Text as="p" color="doveGray" variant="body">
            {secondaryInfo}
          </Text>
        )}
      </div>

      <div className={sprinkles({dir: ['col', 'row'], flex: 'flex', gap: 8})}>
        {secondaryButton && secondaryButton?.href && (
          <NextLink href={secondaryButton?.href} passHref>
            <Button as="a" icon="ArrowRight">
              {secondaryButton.title}
            </Button>
          </NextLink>
        )}

        {primaryButton && primaryButton.href && (
          <NextLink href={primaryButton.href} passHref>
            <Button as="a" variant="secondary" icon="ArrowRight">
              {primaryButton.title}
            </Button>
          </NextLink>
        )}
      </div>
      {steps && renderedProgressTracker}
    </Card>
  );
};
